import script from "./Markdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Markdown.vue?vue&type=script&setup=true&lang=js"

import "./Markdown.vue?vue&type=style&index=0&id=bef0a44c&lang=scss"

const __exports__ = script;

export default __exports__